import React from 'react';
import { StoryCard } from '../StoryCard';

class SortableTriviaCard extends StoryCard {
	render() {
		return <div className="sortable-trivia-card">{super.renderCard()}</div>;
	}
}

export default SortableTriviaCard;
